<template>
  <!-- eslint-disable -->
  <div class="o-page__content">
    <h1 class="u-visually-hidden">About</h1>
    <div class="o-container-sm" v-html="bio"></div>

    <div class="my-large u-text-center">
      <LazyImage
        :round=true
        :lazy-src="portrait"
        :lazy-srcset="portrait"
        :width="220"
        :height="220"
      />
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import LazyImage from '@/components/LazyImage.vue';

export default {
  computed: mapState({
    metaTitle(state) {
      return state.hasLoaded ? state.seo.pages.about.title : state.defaultMetaTitle;
    },
    metaDescription(state) {
      return state.hasLoaded ? state.seo.pages.about.description : state.defaultMetaDescription;
    },
    bio(state) {
      return state.hasLoaded ? state.pages.about.text : '';
    },
    portrait(state) {
      return state.hasLoaded ? state.pages.about.imageSrc : '';
    },
  }),
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.metaDescription,
      }],
    };
  },
  components: { LazyImage },
};
</script>
